const css = `.o9Hc0q__fade{opacity:.5}.o9Hc0q__opacityTransition{transition:opacity .3s}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"fade":"o9Hc0q__fade","opacityTransition":"o9Hc0q__opacityTransition"};
